import { ReactElement, useState } from "react";
import style from "./NodeInfoManager.module.scss"

import { NodeInfo } from "./NodeInfo";
import { DeviceNode } from "../../types/types";
import { useTranslation } from "react-i18next";
import { ExpandableContainer } from "../Misc/ExpandableContainer";

interface Props {
  nodes: DeviceNode[];
}

export function NodeInfoManager({ nodes }: Props): ReactElement {
  const { t } = useTranslation()
  const [showRemoved, setShowRemoved] = useState(false)

  const active = nodes
    .filter(node => !node.removed_time)
    .map(node => <NodeInfo key={node.id} node={node}/>)
  const removed = nodes
    .filter(node => node.removed_time)
    .map(node => <NodeInfo key={node.id} node={node}/>)

  return <>
    <div className={style["node-info-container"]}>
      {active}
    </div>
    {removed.length > 0 &&
      <>
        <div
          className={style.expander}
          onClick={() => setShowRemoved(prev => !prev)}
        >
          <i className={`fa fa-chevron-${showRemoved ? "down" : "right"}`}/>
          <span>{t("Removed devices")}</span>
          <hr/>
        </div>
        <ExpandableContainer show={showRemoved}>
          <div className={style["node-info-container"]}>
            {removed}
          </div>
        </ExpandableContainer>
      </>
    }
  </>
}
